import { Link } from 'apollo-react';
import Close from 'apollo-react-icons/Close';
import Download from 'apollo-react-icons/Download';
import Upload from 'apollo-react-icons/Upload';
import Button from 'apollo-react/components/Button';
import Card from 'apollo-react/components/Card';
import CardContent from 'apollo-react/components/CardContent';
import CardHeader from 'apollo-react/components/CardHeader';
import Container from 'apollo-react/components/Container';
import DatePicker from 'apollo-react/components/DatePicker';
import Divider from 'apollo-react/components/Divider';
import FileUpload from 'apollo-react/components/FileUpload';
import Grid from 'apollo-react/components/Grid';
import InputLabel from 'apollo-react/components/InputLabel';
import Radio from 'apollo-react/components/Radio';
import TextField from 'apollo-react/components/TextField';
import TimePicker from 'apollo-react/components/TimePicker';
import Typography from 'apollo-react/components/Typography';
import { unionWith } from 'lodash';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfirmDialog from '../common/ConfirmDialog';
import { API_URL, NO_SEND_FLG, OBJ_ROLE, PROMPTLY_FLG, STATUS_CODE, SYS_ROLE } from '../common/Constants';
import DetailDialog from '../common/DetailDialog';
import Dialog from '../common/Dialog';
import Loading from '../common/Loading';
import { checkFileName, getApi, getFuncroleFlg, getHeader, postApi, setMessage, setURL, toISOStringWithTimezone, redirectToLogin, MaintenanceApiError, CustomApiError, getBlockedExtensions, isBlockedExtension } from '../common/Utils';
import downloadData from '../json/downloadData.json';
import uploadUpdateData from '../json/uploadUpdateData.json';
import './UploadUpdate.scss';
// スピナー表示　改善
import { CircularProgress } from '@mui/material';
// SignalR接続用のimportを追加
import * as signalR from "@microsoft/signalr";


/**
 * 納品アップロード_変更
 */
function UploadUpdate() {
	const location = useLocation();
	const [t, i18n] = useTranslation();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const DIALOG_STATUS = {
		NO_DIALOG: '0',
		OK_DIALOG: '1',
		DETAIL_DIALOG: '2',
		UPLOAD_CONFIRM_DIALOG: '3',
		UPLOAD_COMPLETE_DIALOG: '4',
		OK_DIALOG_BACK: '5',
		DETAIL_DIALOG_BACK: '6',
	};

	// ファイル保管期間の定数を追加
	const FILE_PERIOD = {
		DAYS_15: '15',
		DAYS_30: '30',
		DAYS_45: '45',
		DAYS_60: '60',
		DAYS_75: '75',
		DAYS_90: '90',
	};

	const [dialogStatus, setDialogStatus] = useState(DIALOG_STATUS.NO_DIALOG);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogContent, setDialogContent] = useState('');
	const [detailContent, setDetailContent] = useState('');
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
	const [confirmDialogContent, setConfirmDialogContent] = useState('');

	// ファイル選択の権限フラグ
	const [uploadFileSelectorAuthFlg, setUploadFileSelectorAuthFlg] = useState(false);
	// ファイルダウンロードリンクの権限フラグ
	const [downloadFileLinkAuthFlg, setDownloadFileLinkAuthFlg] = useState(false);
	// 特記事項の権限フラグ
	const [noticeAuthFlg, setNoticeAuthFlg] = useState(false);
	// お知らせの権限フラグ
	const [informationAuthFlg, setInformationAuthFlg] = useState(false);
	// 公開日時の権限フラグ
	const [openDateChkAuthFlg, setOpenDateChkAuthFlg] = useState(false);
	// 通知メールの送信の権限フラグ
	const [mailSendChkAuthFlg, setMailSendChkAuthFlg] = useState(false);
	// アップロードボタンの権限フラグ
	const [uploadFileBtnAuthFlg, setUploadFileBtnAuthFlg] = useState(false);
	// ステータスによる制御
	const [statusFlg, setStatusFlg] = useState(false);

	// 画面に表示されている情報
	const [formValues, setFormValues] = useState({
		orgCode: '',
		orgName: '',
		serviceCode: '',
		serviceName: '',
		projCode: '',
		projName: '',
		projRateNo: '',
		fileId: '',
		fileName: '',
		selectedFiles: [],
		beforeNotices: '',
		notices: '',
		beforeInformation: '',
		information: '',
		beforePromptlyFlg: '',
		promptlyFlg: '',
		beforeOpenDisplayDate: null,
		openDate: null,
		openDisplayDate: null,
		beforeOpenTime: '',
		openTime: '',
		beforeNoSendFlg: '',
		noSendFlg: '',
		projStatus: '',
		update: '',
		//画面に表示されないが処理で必要のため追加
		beforeOpenDate: '',
		// ★★★ 追加 ★★★
		beforeFilePeriod: FILE_PERIOD.DAYS_90,
		filePeriod: FILE_PERIOD.DAYS_90,
	});
	// エラーのファイル名のリスト
	const [errFileNameMessage, setErrFileNameMessage] = useState('');
	// 新規追加: ブロックされた拡張子リスト
	const [blockedExtensions, setBlockedExtensions] = useState([]);
	const [blockedFileNames, setBlockedFileNames] = useState('');
	// 公開日時の日付形式不正フラグ
	const [openDateFormatErrFlg, setOpenDateFormatErrFlg] = useState(false);
	// 公開日時の過去日判定フラグ
	const [openDatePastErrFlg, setOpenDatePastErrFlg] = useState(false);
	// 公開日時の時刻形式不正フラグ
	const [openTimeFormatErrFlg, setOpenTimeFormatErrFlg] = useState(false);
	// ファイル保管期間の権限フラグ（他の権限フラグと一緒に）
	const [filePeriodAuthFlg, setRetentionPeriodAuthFlg] = useState(false);

	// スピナー表示　改善
	//const [isUploading, setIsUploading] = useState(false);

	/**
	 * アップロード履歴(特定案件)取得APIの成功時の処理
	 * @param {object} response アップロード履歴(特定案件)取得APIのレスポンス
	 */
	function initApiSuccess(response) {
		response.beforeNotices = response.notices;
		response.beforeInformation = response.information;
		response.beforePromptlyFlg = response.promptlyFlg;
		// ★★★ 追加：ファイル保管期間の初期値設定 ★★★
		response.beforeFilePeriod = response.filePeriod || FILE_PERIOD.DAYS_90;
		if (response.promptlyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE) {
			// dayjsオブジェクトを作成
			const openDateDayjs = dayjs(response.openDate);

			// フォーマットされた日付と時間を設定
			response.beforeOpenDisplayDate = openDateDayjs.format('YYYY/MM/DD');
			response.openDisplayDate = openDateDayjs.format('YYYY/MM/DD');
			response.beforeOpenTime = openDateDayjs.format('hh:mm A');
			response.openTime = openDateDayjs.format('hh:mm A');
			response.openDate = response.openDisplayDate;

			const option = { year: 'numeric', month: '2-digit', day: '2-digit' };
			const today = new Date().toLocaleDateString('ja-JP', option);

			// _dプロパティを使わずに、toDate()メソッドを使用してDateオブジェクトに変換
			const openDateObj = openDateDayjs.toDate();
			if (openDateObj.toLocaleDateString('ja-JP', option) < today) {
				setOpenDatePastErrFlg(true);
			}
		}
		response.beforeOpenDate = response.openDate
		response.beforeNoSendFlg = response.noSendFlg;
		const merged = { ...location.state, ...response };
		setFormValues({ ...formValues, ...merged });
		if (response.projStatus === STATUS_CODE.DELIVERY_UPLOAD_COMPLETE || response.projStatus === STATUS_CODE.DELIVERY_STORAGE_COMPLETE) {
			setStatusFlg(true);
		}
	};


	/**
	 * ダウンロードAPIの成功時の処理
	 * @param {object} response ダウンロードAPIのレスポンス
	 */
	async function downloadApiSuccess(response) {
		try {
			const fileName = response.fileDownloadName;
			const options = { 'suggestedName': fileName };
			const handle = await window.showSaveFilePicker(options);
			const writable = await handle.createWritable();
			const blob = new Blob([Uint8Array.from(atob(response.fileContents), str => str.charCodeAt(0))]);
			await writable.write(blob);
			await writable.close();
		} catch (error) {
		}
	};

	/**
	 * アップロードAPIの成功時の処理
	 */
	function uploadSuccess() {
		setDialogStatus(DIALOG_STATUS.UPLOAD_COMPLETE_DIALOG);
		var message = "";
		if (formValues.noSendFlg == NO_SEND_FLG.SEND) {
			message = t('message.1000600');
		} else {
			message = t('message.1000610');
		}
		setDialogOpen(true);
		setDialogContent(message);
	};

	/**
	 * アップロード履歴(特定案件)取得APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function initApiError(error) {
		const detailErrorMessage = '初期処理でエラーが発生しました。\n(An error occurred during the initial processing.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	/**
	 * ダウンロードAPIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function downloadApiError(error) {
		const detailErrorMessage = 'ダウンロード処理でエラーが発生しました。\n(An error occurred during the download process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	/**
	 * アップロードAPIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function uploadError(error) {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {
			// ★ 修正: CustomApiErrorの場合は直接メッセージを表示 ★
			const forbidCharPat1 = /.+403 Forbidden.+/;
			const forbidCharPat2 = /.+Microsoft-Azure-Application-Gateway.+/;
			if ((error.message.match(forbidCharPat1)) && (error.message.match(forbidCharPat2))) {
				const message = t('message.1000810');
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);
			} else {
				// ★ ここを修正: error.messageをそのまま表示 ★
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(error.message);
			}
			
			//認証期限切れの場合は再ログイン
			redirectToLogin();
		} else {
			// ★ その他のエラーのみ詳細ダイアログを表示 ★
			const message = 'アップロード処理でエラーが発生しました。\n(An error occurred during the upload process.)';
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
			setDetailContent(error.stack);

			//認証期限切れの場合は再ログイン
			redirectToLogin();
		}

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	}

	/**
	 * 共通エラー処理
	 * @param {object} error エラーオブジェクト
	 * @param {string} detailErrorMessage 詳細ダイアログに設定するエラーメッセージ
	 */
	const commonError = (error, detailErrorMessage) => {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {
			const message = error.message;
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
		} else {
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(detailErrorMessage);
			setDetailContent(error.stack);
		}
	};

	/**
	 * ファイルのダウンロード時の処理
	 */
	const handleDownloadClick = async () => {
		try {
			//console.log(`[DEBUG] fileName: ${formValues.fileName}`);
			//console.log(`[DEBUG] fileId: ${formValues.fileId}`);
			//console.log(`[DEBUG] projRateNo: ${formValues.projRateNo}, type: ${typeof formValues.projRateNo}`);
				// ファイル保存ダイアログを開きダウンロード先指定
			const fileName = formValues.fileName;
			
			if (!fileName || fileName === 'undefined') {
				console.error('[ERROR] fileName is not defined');
				throw new Error('ファイル名が取得できません');
			}

			const options = { 'suggestedName': fileName };
			const handle = await window.showSaveFilePicker(options);
			const writableStream = await handle.createWritable();
			
			// ダウンロードAPI:
			const url = setURL(API_URL.DOWNLOAD) + '/' + formValues.fileId + '?';
			const params = {};
			params['auditCode'] = formValues.serviceCode;
			params['projCode'] = formValues.projCode;
			params['projRateNo'] = formValues.projRateNo;
			const urlSearchParam = String(new URLSearchParams(params));

			//console.log(`[DEBUG] Download URL: ${url + urlSearchParam}`);
			//console.log(`[DEBUG] projRateNo: ${formValues.projRateNo}`);
			
			let blob;
			if (process.env.NODE_ENV === 'production') {
				// SFTP処理 → streamダウンロードの順で実行
				blob = await startDownload(url + urlSearchParam);
			} else {
				// ローカルデバッグ時は直接プログレスバーを表示
				showProgressBar();
				for (let i = 0; i <= 100; i += 20) {
					updateProgress(i);
					await new Promise(resolve => setTimeout(resolve, 100));
				}
				blob = new Blob([createLargeContent(100)], { type: 'text/csv' });
			}
			
			// Blobデータを書き込む
			await writableStream.write(blob);
			await writableStream.close();
	
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			const message = t('message.1000930');
			setDialogOpen(true);
			setDialogContent(message);
	
		} catch (error) {
			if (error instanceof DOMException) {
				// ファイル保存ダイアログを閉じただけなので何もしない
			} else {
				const detailErrorMessage = 'ダウンロード処理でエラーが発生しました。\n(An error occurred during the download process.)';
				console.error(`[ERROR] ダウンロード処理でエラーが発生: ${error.message}`);
				commonError(error, detailErrorMessage);
			}
		} finally {
			hideProgressBar();
		}
	};
	
	// 指定したサイズの文字列を生成
	const createLargeContent = (sizeInMB = 10) => {
		const oneMB = 1024 * 1024;
		const targetSize = sizeInMB * oneMB;
		const chunk = 'test,data,sample,content,'.repeat(1000); // 約20KB
		const chunksNeeded = Math.ceil(targetSize / chunk.length);

		return chunk.repeat(chunksNeeded).substring(0, targetSize);
	};

	// 既存の状態変数の後に追加
	const [showProgress, setShowProgress] = useState(false);
	const [progressValue, setProgressValue] = useState(0);
	// ★★★ 追加：アップロード用プログレス状態 ★★★
	const [showUploadProgress, setShowUploadProgress] = useState(false);
	const [uploadProgressValue, setUploadProgressValue] = useState(0);

	// showProgressBar関数を修正
	const showProgressBar = () => {
		setShowProgress(true);
		setProgressValue(0);
	};

	// updateProgress関数を修正
	const updateProgress = (percentage) => {
		setProgressValue(percentage);
	};

	// hideProgressBar関数を追加
	const hideProgressBar = () => {
		setShowProgress(false);
		setProgressValue(0);

	// ★★★ 追加：アップロード用プログレス関数 ★★★
	const showUploadProgressBar = () => {
		setShowUploadProgress(true);
		setUploadProgressValue(0);
	};

	const updateUploadProgress = (percentage) => {
		setUploadProgressValue(percentage);
	};

	const hideUploadProgressBar = () => {
		setShowUploadProgress(false);
		setUploadProgressValue(0);
	};
	// DOM操作も併用して確実に非表示
	// const blockElement = document.getElementById('block');
	// if (blockElement) {
	// 	blockElement.style.display = 'none';
	// }
	};

	// チャンク分割ダウンロード関数
	const downloadWithChunks = async (url) => {
		try {
			//console.log(`[INFO] Starting chunk download for: ${url}`);
			
			// まずファイルサイズを取得
			const headResponse = await fetch(url, { 
				method: 'HEAD',
				headers: getHeader(SYS_ROLE.UPLOAD_UPDATE).headers
			});
			
			//console.log(`[DEBUG] HEAD response status: ${headResponse.status}`);
			//console.log(`[DEBUG] HEAD response headers:`, Object.fromEntries(headResponse.headers.entries()));
			
			if (!headResponse.ok) {
				throw new Error(`ファイル情報の取得に失敗しました: ${headResponse.status}`);
			}
			
			const contentLengthHeader = headResponse.headers.get('Content-Length');
			//console.log(`[DEBUG] Content-Length header: ${contentLengthHeader}`);
			
			const totalSize = parseInt(contentLengthHeader || '0');
			
			// 0バイトファイルの場合は空のBlobを返す
			if (totalSize === 0) {
				console.log('[INFO] 0-byte file detected, returning empty blob');
				updateProgress(100); // 100%完了として扱う
				return new Blob([], { type: 'application/octet-stream' });
			}
			
			//console.log(`[INFO] Total file size: ${totalSize} bytes (${(totalSize / 1024 / 1024).toFixed(2)} MB)`);
			
			// 655バイトの場合は異常なので、通常のダウンロードにフォールバック
			if (totalSize < 1000) {
				console.warn(`[WARN] Suspicious file size: ${totalSize} bytes. Falling back to normal download.`);
				throw new Error('ファイルサイズが異常に小さいです');
			}
			
			const chunkSize = 10 * 1024 * 1024; // 10MB chunks
			const chunks = [];
			let downloaded = 0;
			
			const totalChunks = Math.ceil(totalSize / chunkSize);
			//console.log(`[INFO] Total chunks: ${totalChunks}`);
			
			// downloadWithChunks関数内のプログレス計算を修正
			for (let start = 0; start < totalSize; start += chunkSize) {
				const end = Math.min(start + chunkSize - 1, totalSize - 1);
				const chunkIndex = Math.floor(start / chunkSize) + 1;
				
				//console.log(`[INFO] Downloading chunk ${chunkIndex}/${totalChunks}: ${start}-${end} (${end - start + 1} bytes)`);
				
				const chunk = await downloadChunk(url, start, end);
				
				const expectedSize = end - start + 1;
				if (chunk.size !== expectedSize) {
					console.warn(`[WARN] Chunk size mismatch. Expected: ${expectedSize}, Got: ${chunk.size}`);
				}
				
				chunks.push(chunk);
				downloaded += chunk.size;
				
				// プログレス計算を修正：70-100%の範囲でマッピング
				const chunkProgress = (downloaded / totalSize) * 100;
				const mappedProgress = 70 + (chunkProgress * 0.3); // 70% + (0-30%)
				updateProgress(Math.round(mappedProgress));
				
				//console.log(`[INFO] Downloaded chunk ${chunkIndex}/${totalChunks}: ${chunk.size} bytes. Total: ${downloaded}/${totalSize} bytes (${mappedProgress.toFixed(1)}%)`);
			}
			
			//console.log(`[INFO] All chunks downloaded. Creating final blob from ${chunks.length} chunks`);
			const finalBlob = new Blob(chunks);
			//console.log(`[INFO] Final blob size: ${finalBlob.size} bytes (${(finalBlob.size / 1024 / 1024).toFixed(2)} MB)`);
			
			if (finalBlob.size !== totalSize) {
				console.error(`[ERROR] Final blob size mismatch! Expected: ${totalSize}, Got: ${finalBlob.size}`);
			}
			
			return finalBlob;
			
		} catch (error) {
			console.error(`[ERROR] Chunk download failed: ${error.message}`);
			throw error;
		}
	};

	// 個別チャンクダウンロード関数
	const downloadChunk = (url, start, end) => {
		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			xhr.responseType = 'blob';
			xhr.timeout = 10 * 60 * 1000; // 10分タイムアウト（チャンクごと）
			
			xhr.addEventListener('load', () => {
				if (xhr.status === 206 || xhr.status === 200) {
					const blob = xhr.response;
					const expectedSize = end - start + 1;
					
					//console.log(`[DEBUG] Chunk response: status=${xhr.status}, size=${blob.size}, expected=${expectedSize}`);
					
					if (blob.size === 0) {
						reject(new Error(`Empty chunk received for range ${start}-${end}`));
						return;
					}
					
					resolve(blob);
				} else {
					console.error(`[ERROR] Chunk download failed: status=${xhr.status}, range=${start}-${end}`);
					reject(new Error(`Chunk download failed: ${xhr.status}`));
				}
			});
			
			xhr.addEventListener('error', (event) => {
				console.error(`[ERROR] Chunk network error for range ${start}-${end}:`, event);
				reject(new Error('Chunk download network error'));
			});
			
			xhr.addEventListener('timeout', () => {
				console.error(`[ERROR] Chunk timeout for range ${start}-${end}`);
				reject(new Error('Chunk download timeout'));
			});
			
			xhr.open('GET', url);
			
			// Rangeヘッダーを設定
			xhr.setRequestHeader('Range', `bytes=${start}-${end}`);
			//console.log(`[DEBUG] Setting Range header: bytes=${start}-${end}`);
			
			// その他のヘッダーを設定
			const headers = getHeader(SYS_ROLE.UPLOAD_UPDATE);
			if (headers && headers.headers) {
				Object.entries(headers.headers).forEach(([key, value]) => {
					if (key.toLowerCase() !== 'range') {
						xhr.setRequestHeader(key, value);
					}
				});
			}
			
			xhr.send();
		});
	};

	// XMLHttpRequestを使用してプログレス付きダウンロード
	const downloadWithProgress = async (url) => {
		try {
			// チャンク分割ダウンロードを使用
			return await downloadWithChunks(url);
		} catch (error) {
			console.error(`[ERROR] Chunk download failed, falling back to normal download: ${error.message}`);
			
			// フォールバック：通常のダウンロード
			return new Promise((resolve, reject) => {
				const xhr = new XMLHttpRequest();
				xhr.timeout = 4 * 60 * 60 * 1000;
				xhr.responseType = 'blob';
				
				xhr.addEventListener('progress', (event) => {
					if (event.lengthComputable) {
						const percentage = (event.loaded / event.total) * 100;
						updateProgress(percentage);
					}
				});

				xhr.addEventListener('timeout', () => {
					reject(new Error('ダウンロードがタイムアウトしました'));
				});

				xhr.addEventListener('load', () => {
					if (xhr.status === 200) {
						resolve(new Blob([xhr.response]));
					} else if (xhr.status === 206) { // Partial Content
						resolve(new Blob([xhr.response]));
					} else if (xhr.status === 503) {
						localStorage.removeItem("funcroleList");
						reject(new MaintenanceApiError());
					} else {
						const reader = new FileReader();
						reader.onload = () => {
							reject(new CustomApiError(reader.result));
						};
						reader.onerror = () => {
							reject(new CustomApiError("不明なエラーが発生しました"));
						};
						reader.readAsText(xhr.response);
					}
				});

				xhr.addEventListener('error', () => {
					reject(new Error('ダウンロードエラーが発生しました'));
				});

				xhr.open('GET', url);
				
				const headers = getHeader(SYS_ROLE.UPLOAD_UPDATE);
				if (headers && headers.headers) {
					Object.entries(headers.headers).forEach(([key, value]) => {
						if (key.toLowerCase() !== 'connection' && key.toLowerCase() !== 'upgrade') {
							xhr.setRequestHeader(key, value);
						}
					});
				}

				xhr.send();
			});
		}
	};

	// SFTP対応ダウンロード処理（SignalR対応版）
	async function startDownload(remotePath) {
		return new Promise(async (resolve, reject) => {
			try {
				// SFTP処理開始時にプログレスバーを表示（スピナーではなく）
				showProgressBar();
				updateProgress(0); // 0%から開始
				
				// ① ジョブ開始APIを呼び出して、ジョブIDを取得
				const res = await fetch('/api/start-download', {
					method: 'POST',
					headers: { 
						'Content-Type': 'application/json',
						...getHeader(SYS_ROLE.UPLOAD_UPDATE).headers
					},
					body: JSON.stringify({ remotePath })
				});

				if (!res.ok) {
					const errorText = await res.text();
					console.error(`[ERROR] Start download failed: ${res.status} - ${errorText}`);
					throw new Error(`ジョブ開始に失敗しました: ${res.status}`);
				}

				const { jobId } = await res.json();
				
				// SignalR接続を確立
				const connection = new signalR.HubConnectionBuilder()
					.withUrl("/progressHub")
					.build();

				// 接続開始
				await connection.start();
				//console.log('[INFO] SignalR connection established');

				// ジョブグループに参加
				await connection.invoke("JoinGroup", jobId);

				// プログレス更新を監視
				connection.on("ProgressUpdate", (progressData) => {
					//console.log('[INFO] Progress update received:', progressData);
					
					switch (progressData.type) {
						case 'sftp_start':
							updateProgress(1); // SFTP開始時に1%
							break;
							
						case 'sftp_connected':
							updateProgress(2); // SFTP接続完了時に2%
							break;
							
						case 'sftp_progress':
							// SFTP進捗を2-70%の範囲でマッピング
							const sftpProgress = Math.min(progressData.percentage || 0, 100);
							const mappedProgress = 2 + (sftpProgress * 0.68); // 2% + (0-68%)
							updateProgress(Math.round(mappedProgress));
							break;
							
						case 'sftp_completed':
							updateProgress(70); // SFTP完了時に70%
							break;
							
						case 'download_start':
							updateProgress(75); // ダウンロード開始時に75%
							break;
							
						case 'download_completed':
							updateProgress(100); // ダウンロード完了時に100%
							//console.log('[INFO] Download completed via SignalR');
							break;
							
						case 'download_error':
						case 'error':
							console.error('[ERROR] Download error via SignalR:', progressData.message);
							break;
					}
				});
				
				// タイムアウト設定（4時間）
				const timeout = setTimeout(() => {
					connection.stop();
					reject(new Error('ダウンロードがタイムアウトしました'));
				}, 4 * 60 * 60 * 1000);

				// ② ポーリングでジョブステータスを定期確認
				const interval = setInterval(async () => {
					try {
						const statusRes = await fetch(`/api/job-status/${jobId}`, {
							headers: getHeader(SYS_ROLE.UPLOAD_UPDATE).headers
						});
						
						if (!statusRes.ok) {
							throw new Error(`ステータス確認に失敗しました: ${statusRes.status}`);
						}
						
						const { status } = await statusRes.json();

						if (status === 'Completed') {
							clearInterval(interval);
							clearTimeout(timeout);
							
							// SignalR接続を終了
							await connection.invoke("LeaveGroup", jobId);
							await connection.stop();
							
							// ダウンロードURLを生成して、downloadWithProgressで取得
							const downloadUrl = `/api/download-job/${jobId}`;
							const blob = await downloadWithProgress(downloadUrl);
							resolve(blob);
							
						} else if (status === 'Failed') {
							clearInterval(interval);
							clearTimeout(timeout);
							await connection.stop();
							reject(new Error('ダウンロードに失敗しました'));
						}
					} catch (error) {
						clearInterval(interval);
						clearTimeout(timeout);
						await connection.stop();
						reject(error);
					}
				}, 3000);
				
			} catch (error) {
				reject(error);
			}
		});
	}

	/**
	 * ファイル選択時の処理
	 * @param {object} files 選択したファイルの情報
	 */
	const handleUploadFile = (files) => {
		const selectedFiles = unionWith(
			formValues.selectedFiles,
			files,
			(item1, item2) => item1.name === item2.name,
		);
		
		// 既存のファイル名チェック
		const errFileNameList = selectedFiles
			.filter(file => checkFileName(file.name) === false)
			.map(file => file.name);
		
		// ★ 拡張子ブロックリストチェックを追加 ★
		const blockedFileList = selectedFiles
			.filter(file => isBlockedExtension(file.name, blockedExtensions))
			.map(file => file.name);
		
		if (errFileNameList.length > 0) {
			setErrFileNameMessage(errFileNameList.join(', '));
		} else {
			setErrFileNameMessage('');
		}
		
		// ★ ブロックされたファイルのエラーメッセージを設定 ★
		if (blockedFileList.length > 0) {
			setBlockedFileNames(blockedFileList.join(', '));
		} else {
			setBlockedFileNames('');
		}
		
		setFormValues({ ...formValues, selectedFiles });
	}


	/**
	 * ファイル削除時の処理
	 * @param {object} file 削除したファイルの情報
	 */
	const handleDeleteFile = (file) => {
		const selectedFiles = formValues.selectedFiles.filter((item) => item.name !== file.name);
		
		// 既存のファイル名チェック
		const errFileNameList = selectedFiles
			.filter(file => checkFileName(file.name) === false)
			.map(file => file.name);
		
		// ★ 拡張子ブロックリストチェックを追加 ★
		const blockedFileList = selectedFiles
			.filter(file => isBlockedExtension(file.name, blockedExtensions))
			.map(file => file.name);
		
		if (errFileNameList.length > 0) {
			setErrFileNameMessage(errFileNameList.join(', '));
		} else {
			setErrFileNameMessage('');
		}
		
		// ★ ブロックされたファイルのエラーメッセージを設定 ★
		if (blockedFileList.length > 0) {
			setBlockedFileNames(blockedFileList.join(', '));
		} else {
			setBlockedFileNames('');
		}
		
		setFormValues({ ...formValues, selectedFiles });
	}


	/**
	 * 公開日時で即時公開を選択時の処理
	 */
	const selectPublishImmediately = () => {
		setFormValues({ ...formValues, promptlyFlg: PROMPTLY_FLG.PUBLISH_IMMEDIATELY, openDate: null, openDisplayDate: dayjs(null), openTime: '' });
		clearOpenDateErrFlg();
		setOpenTimeFormatErrFlg(false);
	};

	/**
	 * 公開日時の日付入力時の処理
	 * @param {string} date 入力した日付
	 */
	const inputDate = (date) => {
		const option = { year: 'numeric', month: '2-digit', day: '2-digit' };
		const today = new Date().toLocaleDateString('ja-JP', option);

		if (date === '') {
			setFormValues({ ...formValues, openDate: null, openDisplayDate: null });
			clearOpenDateErrFlg();
		} else {
			// 日付文字列から曜日部分を削除（例：2025/05/Th → 2025/05）
			const cleanDate = date.replace(/\/[A-Za-z][a-z]+$/, '');

			// 日付をパース (大文字のYYYYを使用)
			const parsedDate = dayjs(cleanDate, 'YYYY/MM/DD', true);

			if (!parsedDate.isValid()) {
				setFormValues({ ...formValues, openDate: parsedDate, openDisplayDate: null });
				setOpenDateFormatErrFlg(true);
				setOpenDatePastErrFlg(false);
			} else {
				// _d の代わりに toDate() を使用
				const dateObj = parsedDate.toDate();
				const formattedDate = dateObj.toLocaleDateString('ja-JP', option);

				if (today <= formattedDate) {
					setFormValues({ ...formValues, openDate: parsedDate, openDisplayDate: parsedDate });
					clearOpenDateErrFlg();
				} else {
					setFormValues({ ...formValues, openDate: parsedDate, openDisplayDate: parsedDate });
					setOpenDateFormatErrFlg(false);
					setOpenDatePastErrFlg(true);
				}
			}
		}
	};

	/**
	 * 公開日のエラーフラグをfalseに設定する処理
	 */
	const clearOpenDateErrFlg = () => {
		setOpenDateFormatErrFlg(false);
		setOpenDatePastErrFlg(false);
	};

	/**
	 * 公開日時の時刻入力時の処理
	 * @param {string} time 入力した時刻
	 */
	const inputTime = (time) => {
		console.log('Input time received:', time); // デバッグ用
		setFormValues({ ...formValues, openTime: time });

		if (!time || time === '') {
			setOpenTimeFormatErrFlg(false);
			return;
		}


		// 複数のフォーマットを試す
		const isValid =
			dayjs(time, 'HH:mm', true).isValid() ||  // 24時間形式 (例: 14:30)
			dayjs(time, 'hh:mm A', true).isValid() || // 12時間形式 (例: 02:30 PM)
			dayjs(time, 'h:mm A', true).isValid() ||  // 先頭の0なし (例: 2:30 PM)
			dayjs(time, 'h:mm a', true).isValid() ||  // 小文字のam/pm (例: 1:00 am)
			/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time) || // 正規表現: HH:mm
			/^([0-1]?[0-9]):[0-5][0-9] (AM|PM|am|pm)$/.test(time); // 正規表現: h:mm AM/PM


		console.log('Is valid time:', isValid); // デバッグ用
		setOpenTimeFormatErrFlg(!isValid);
	};

	/**
	 * アップロードボタン押下時の処理
	 */
	const handleUploadClick = () => {
		var message = "";
		if (formValues.promptyFlg == "0") {
			// openDateはDateオブジェクトなので、dayjsでラップしてからフォーマット
			const openDateStr = dayjs(formValues.openDate).format('YYYY-MM-DD');
			var openDate = toISOStringWithTimezone(dayjs(openDateStr + ' ' + formValues.openTime).toDate());
			var now = toISOStringWithTimezone(new Date());
			//指定した公開日時が現在時刻以前の場合はメッセージ表示
			if (openDate <= now) {
				message = t('message.1001300');
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);
			} else {
				message = t('message.1000500');
				setDialogStatus(DIALOG_STATUS.UPLOAD_CONFIRM_DIALOG);
				setConfirmDialogOpen(true);
				setConfirmDialogContent(message)
			}
		} else {
			message = t('message.1000500');
			setDialogStatus(DIALOG_STATUS.UPLOAD_CONFIRM_DIALOG);
			setConfirmDialogOpen(true);
			setConfirmDialogContent(message)
		}
	}

	/**
	 * ダイアログでOKボタン押下時の処理
	 */
	const onOk = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setDialogOpen(false);
		if (dialogStatus === DIALOG_STATUS.OK_DIALOG_BACK || dialogStatus === DIALOG_STATUS.DETAIL_DIALOG_BACK) {
			// 納品ファイル管理画面へ遷移
			const param = {
				org: location.state.orgCode,
				service: location.state.serviceCode,
				proj: location.state.projCode,
			};
			navigate('/deliveryfilemanagement', { state: param });
		}

	};

	/**
	 * アップロード時の確認ダイアログでOKボタン押下時の処理
	 */
	const onUploadConfirmOk = async () => {
		setConfirmDialogOpen(false);
		
		// ★★★ 修正：アップロード用プログレスバーを表示 ★★★
		showUploadProgressBar();
		
		let formData = new FormData();
		formData.append('auditCode', formValues.serviceCode);
		formData.append('projCode', formValues.projCode);
		formData.append('notices', formValues.notices);
		formData.append('information', formValues.information);
		formData.append('promptlyFlg', formValues.promptlyFlg);
		formData.append('update', formValues.update);
		formData.append('beforeFileName', formValues.fileName);
		formData.append('beforeFileId', formValues.fileId);
		// ★★★ 追加：ファイル保管期間を追加 ★★★
		formData.append('filePeriod', formValues.filePeriod);

		//公開日時入力
		if (formValues.promptlyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE) {
			const openDateStr = dayjs(formValues.openDate).format('YYYY-MM-DD');
			formData.append('openDate', toISOStringWithTimezone(dayjs(openDateStr + ' ' + formValues.openTime).toDate()));
		} else if (formValues.promptlyFlg === PROMPTLY_FLG.PUBLISH_IMMEDIATELY && formValues.beforePromptlyFlg === PROMPTLY_FLG.PUBLISH_IMMEDIATELY) {
			formData.append('openDate', toISOStringWithTimezone(new Date(formValues.beforeOpenDate)));
		} else if (formValues.promptlyFlg === PROMPTLY_FLG.PUBLISH_IMMEDIATELY && formValues.beforePromptlyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE) {
			formData.append('openDate', toISOStringWithTimezone(new Date()));
		};
		formData.append('noSendFlg', formValues.noSendFlg);
		
		let url;
		if (formValues.selectedFiles.length === 0) {
			formData.append('projRateNo', formValues.projRateNo);
			url = setURL(API_URL.PROJECT);
		} else {
			formData.append('orgLevel0Code', formValues.orgCode);
			for (let selectedFile of formValues.selectedFiles) {
				formData.append('file', selectedFile);
			}
			url = setURL(API_URL.UPLOAD_IQVIA_REPLACE);
		}

		try {
			// ★★★ 修正：プログレス対応のpostApiを使用 ★★★
			const postApiParam = {
				url: url,
				sysRole: SYS_ROLE.UPLOAD_UPDATE,
				body: formData,
			};
			
			await postApiWithProgress(postApiParam);
			hideUploadProgressBar();
			uploadSuccess();
			
		} catch (error) {
			hideUploadProgressBar();
			uploadError(error);
		}
	};

	/**
	 * 確認ダイアログでキャンセルボタン押下時の処理
	 */
	const onCancel = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setConfirmDialogOpen(false);
	};

	/**
	 * 共通納品ファイル管理遷移処理
	 */
	const commonBack = () => {
		const param = {
			service: formValues.serviceCode,
			org: formValues.orgCode,
			proj: formValues.projCode,
		};
		// 納品ファイル管理画面へ遷移
		navigate('/deliveryfilemanagement', { state: param });
	};

	/**
	 * アップロード完了ダイアログでOKボタン押下時の処理
	 */
	const onCompleteOk = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setDialogOpen(false);
		commonBack();
	};

	/**
	 * キャンセルボタン押下時の処理
	 */
	const handleCancelClick = () => {
		commonBack();
	}

	/**
	 * アップロード用プログレスバーを表示
	 */
	const showUploadProgressBar = () => {
		setShowUploadProgress(true);
		setUploadProgressValue(0);
	};

	/**
	 * アップロード用プログレスを更新
	 */
	const updateUploadProgress = (percentage) => {
		setUploadProgressValue(percentage);
	};

	/**
	 * アップロード用プログレスバーを非表示
	 */
	const hideUploadProgressBar = () => {
		setShowUploadProgress(false);
		setUploadProgressValue(0);
	};


	// ★★★ 追加：プログレス対応のpostApi関数 ★★★
	const postApiWithProgress = (apiParam) => {
		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			xhr.timeout = 4 * 60 * 60 * 1000; // 4時間タイムアウト

			// アップロードプログレスを監視
			xhr.upload.addEventListener('progress', (event) => {
				if (event.lengthComputable) {
					const percentage = (event.loaded / event.total) * 100;
					updateUploadProgress(Math.round(percentage));
				}
			});

			xhr.addEventListener('load', () => {
				if (xhr.status === 200) {
					try {
						const response = JSON.parse(xhr.responseText);
						resolve(response);
					} catch (error) {
						resolve(xhr.responseText);
					}
				} else if (xhr.status === 400) {
					// ★ 修正: 400エラーの場合、レスポンステキストを直接取得 ★
					const errorMessage = xhr.responseText || `Bad Request: Status ${xhr.status}`;
					console.error('Upload error (400):', errorMessage);
					reject(new CustomApiError(errorMessage));
				} else if (xhr.status === 503) {
					localStorage.removeItem("funcroleList");
					reject(new MaintenanceApiError());
				} else {
					// ★ 修正: その他のエラーもレスポンステキストを取得 ★
					const errorMessage = xhr.responseText || `アップロードに失敗しました: ${xhr.status}`;
					reject(new CustomApiError(errorMessage));
				}
			});

			xhr.addEventListener('error', () => {
				reject(new Error('アップロードエラーが発生しました'));
			});

			xhr.addEventListener('timeout', () => {
				reject(new Error('アップロードがタイムアウトしました'));
			});

			xhr.open('POST', apiParam.url);
			
			// ヘッダーを設定
			const headers = getHeader(apiParam.sysRole);
			if (headers && headers.headers) {
				Object.entries(headers.headers).forEach(([key, value]) => {
					if (key.toLowerCase() !== 'content-type') { // FormDataの場合はContent-Typeを自動設定
						xhr.setRequestHeader(key, value);
					}
				});
			}

			xhr.send(apiParam.body);
		});
	};

	useEffect(() => {
		(async () => {
			if (location.state === null) {
				// 納品ファイル管理画面へ遷移
				navigate('/deliveryFilemanagement');
				return;
			}
			// ブロックされた拡張子リストを取得
			const extensions = await getBlockedExtensions();
			setBlockedExtensions(extensions);
			// ファイル選択の権限フラグを設定
			setUploadFileSelectorAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_UPDATE, OBJ_ROLE.UPLOAD_FILE_SELECTOR));
			// ファイルダウンロードリンクの権限フラグを設定
			setDownloadFileLinkAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_UPDATE, OBJ_ROLE.DOWNLOAD_FILE_LINK));
			// 特記事項の権限フラグを設定
			setNoticeAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_UPDATE, OBJ_ROLE.NOTICES));
			// お知らせの権限フラグを設定
			setInformationAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_UPDATE, OBJ_ROLE.INFORMATION));
			// 公開日時の権限フラグを設定
			setOpenDateChkAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_UPDATE, OBJ_ROLE.OPEN_DATE_CHK));
			// 通知メールの送信の権限フラグを設定
			setMailSendChkAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_UPDATE, OBJ_ROLE.MAIL_SEND_CHK));
			// アップロードボタンの権限フラグを設定
			setUploadFileBtnAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_UPDATE, OBJ_ROLE.UPLOAD_FILE_BTN));
			// ★★★ 追加：ファイル保管期間の権限フラグを設定 ★★★
			setRetentionPeriodAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_UPDATE, OBJ_ROLE.FILE_PERIOD_CHK));

			// アップロード履歴(特定案件)取得API
			const url = setURL(API_URL.UPHIST_IQVIA);
			const id = location.state.serviceCode + '_' + location.state.projCode + '_' + location.state.projRateNo + '_' + location.state.fileId;
			const getApiParam = {
				url: url + '/' + id,
				sysRole: SYS_ROLE.UPLOAD_UPDATE,
				success: initApiSuccess,
				error: initApiError,
				json: structuredClone(uploadUpdateData),
			}
			await getApi(getApiParam);
			setIsLoading(false);
		})();
	}, []);

	if (isLoading) {
		// ロード中の場合はローディング画面
		return (
			<Loading />
		);
	} else {
		return (
			<Container className="uploadUpdate" maxWidth="md">
				{/* プログレスバーを修正 */}
				{showProgress && (
					<div style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						backgroundColor: 'rgba(0, 0, 0, 0.5)',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						zIndex: 9999,
					}}>
						<div style={{
							background: 'white',
							padding: '30px',
							borderRadius: '8px',
							textAlign: 'center',
							boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
							minWidth: '350px',
						}}>
							<p style={{ margin: '0 0 20px 0', fontSize: '16px', color: '#333' }}>
								{progressValue < 70 ? 'サーバーからファイルを取得中...' : 'ファイルをダウンロード中...'}
							</p>
							<div style={{
								width: '100%',
								height: '20px',
								backgroundColor: '#f0f0f0',
								borderRadius: '10px',
								overflow: 'hidden',
								marginBottom: '10px',
							}}>
								<div style={{
									height: '100%',
									backgroundColor: progressValue < 70 ? '#ff9800' : '#3498db', // SFTP中はオレンジ、ダウンロード中は青
									width: `${progressValue}%`,
									transition: 'width 0.3s ease, background-color 0.3s ease',
									borderRadius: '10px',
								}}></div>
							</div>
							<span style={{ fontSize: '14px', color: '#666' }}>
								{Math.round(progressValue)}%
							</span>
							<p style={{ margin: '10px 0 0 0', fontSize: '12px', color: '#999' }}>
								{progressValue < 70 ? 'ファイルサイズによってはお時間をいただく場合があります' : 'もうすぐ完了します'}
							</p>
						</div>
					</div>
				)}
				{/* ★★★ 追加：アップロード用プログレスバー ★★★ */}
				{showUploadProgress && (
					<div style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						backgroundColor: 'rgba(0, 0, 0, 0.5)',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						zIndex: 9999,
					}}>
						<div style={{
							background: 'white',
							padding: '30px',
							borderRadius: '8px',
							textAlign: 'center',
							boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
							minWidth: '350px',
						}}>
							<p style={{ margin: '0 0 20px 0', fontSize: '16px', color: '#333' }}>
								ファイルをアップロード中...
							</p>
							<div style={{
								width: '100%',
								height: '20px',
								backgroundColor: '#f0f0f0',
								borderRadius: '10px',
								overflow: 'hidden',
								marginBottom: '10px',
							}}>
								<div style={{
									height: '100%',
									backgroundColor: '#4caf50', // アップロード中は緑色
									width: `${uploadProgressValue}%`,
									transition: 'width 0.3s ease',
									borderRadius: '10px',
								}}></div>
							</div>
							<span style={{ fontSize: '14px', color: '#666' }}>
								{Math.round(uploadProgressValue)}%
							</span>
							<p style={{ margin: '10px 0 0 0', fontSize: '12px', color: '#999' }}>
								ファイルサイズによってはお時間をいただく場合があります
							</p>
						</div>
					</div>
				)}
				<Card className="card">
					<CardHeader
						title={t('uploadDelivery')}
						subheader={t('uploadDeliveryScreenDescription')}
					/>
					<CardContent>
						<Grid container>
							<Grid item md={12} className="griditem">
								<TextField
									label={'1. ' + t('selectService')}
									value={formValues.serviceName}
									disabled
									InputLabelProps={{ style: { width: '400px' }}}
								/>
							</Grid>
							<Grid item md={12} className="griditem">
								<TextField
									label={'2. ' + t('selectOrg')}
									value={formValues.orgName}
									disabled
									InputLabelProps={{ style: { width: '400px' }}}
								/>
							</Grid>
							<Grid item md={12} className="griditem">
								<TextField
									label={'3. ' + t('selectProj')}
									value={formValues.projName}
									disabled
									InputLabelProps={{ style: { width: '400px' }}}
								/>
							</Grid>
							<Grid item md={12} className="griditem uploadFileSelector">
								<InputLabel>{'4. ' + t('uploadFileSelect')}</InputLabel>
								<InputLabel >{t('beforeUploadFile')}</InputLabel>
								<Link className="downloadFileLink" style={{ display: 'inline-flex', alignItems: 'center' }} disabled={!downloadFileLinkAuthFlg || !statusFlg} onClick={handleDownloadClick}>
									<Download fontSize="small" />{formValues.fileName}
								</Link>
								<div className='afterUploadFile'>
									<FileUpload
										label={t('afterUploadFile')}
										value={formValues.selectedFiles}
										onUpload={handleUploadFile}
										onFileDelete={handleDeleteFile}
										disabled={!uploadFileSelectorAuthFlg || !statusFlg}
										dropAreaLabels={{
											browseLinkText: t('dropAreaBrowseLinkText'),
											hoverText: t('dropAreaHoverText'),
										}}
										fullWidth
									/>
								</div>
								{errFileNameMessage.length !== 0 && (
									<Typography className='errorMessage' variant='caption'>
										{setMessage(t('message.1000800'), [errFileNameMessage])}
									</Typography>
								)}
								{blockedFileNames.length !== 0 && (
									<Typography className='errorMessage' variant='caption'>
										次のファイルはセキュリティ上の理由によりアップロードできません: {blockedFileNames}
									</Typography>
								)}
							</Grid>
						</Grid>
						<Grid item md={12} className="griditem notices">
							<Typography variant="caption">
								{'5. ' + t('notice')}
							</Typography>
							<TextField
								label={t('beforeNotice')}
								value={formValues.beforeNotices}
								multiline
								minRows="2"
								fullWidth
								disabled
							/>
							<TextField
								label={t('afterNotice')}
								helperText={formValues.notices.length > 300 ? setMessage(t('message.1000300'), [t('notice').toLowerCase(), 300]) : t('helperTextNotice')}
								value={formValues.notices}
								onChange={(e) => setFormValues({ ...formValues, notices: e.target.value })}
								error={formValues.notices.length > 300}
								multiline
								minRows="2"
								optional
								fullWidth
								disabled={!noticeAuthFlg || !statusFlg}
							/>
						</Grid>
						<Grid item md={12} className="griditem information">
							<Typography variant="caption">
								{'6. ' + t('information')}
							</Typography>
							<TextField
								label={t('beforeInformation')}
								value={formValues.beforeInformation}
								multiline
								minRows="2"
								fullWidth
								disabled
							/>
							<TextField
								label={t('afterInformation')}
								helperText={formValues.information.length > 300 ? setMessage(t('message.1000300'), [t('information').toLowerCase(), 300]) : t('helperTextInformation')}
								value={formValues.information}
								onChange={(e) => setFormValues({ ...formValues, information: e.target.value })}
								error={formValues.information.length > 300}
								multiline
								minRows="2"
								optional
								fullWidth
								disabled={!informationAuthFlg || !statusFlg}
							/>
						</Grid>
						<Grid item md={12} className="griditem openDateChk">
							<InputLabel required >{'7. ' + t('publishedDate')}</InputLabel>
							<InputLabel className='beforePublishedDateLabel'>{t('beforePublishedDate')}</InputLabel>
							<Radio
								label={t('publishImmediately')}
								checked={formValues.beforePromptlyFlg === PROMPTLY_FLG.PUBLISH_IMMEDIATELY}
								disabled
							/>
							<br />
							<Radio
								label={t('publishSelectedDatetime')}
								checked={formValues.beforePromptlyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE}
								disabled
							/>
							<div>
								<DatePicker
									placeholder={formValues.beforeOpenDisplayDate}
									dateFormat='YYYY/MM/DD'
									disabled
								/>
								<TimePicker
									value={formValues.beforeOpenTime}
									disabled
								/>
							</div>
							<InputLabel >{t('afterPublishedDate')}</InputLabel>
							<Radio
								label={t('publishImmediately')}
								checked={formValues.promptlyFlg === PROMPTLY_FLG.PUBLISH_IMMEDIATELY}
								onChange={selectPublishImmediately}
								disabled={!openDateChkAuthFlg || !statusFlg}
							/>
							<br />
							<Radio
								label={t('publishSelectedDatetime')}
								checked={formValues.promptlyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE}
								onChange={() => setFormValues({ ...formValues, promptlyFlg: PROMPTLY_FLG.PUBLISH_SELECT_DATE })}
								disabled={!openDateChkAuthFlg || !statusFlg}
							/>
							<div>
								<DatePicker
									className='openDate'
									helperText={openDateFormatErrFlg ? t('message.1000400') : openDatePastErrFlg ? t('message.1001300') : ''}
									onInputChange={inputDate}
									minDate={new Date()}
									error={openDateFormatErrFlg || openDatePastErrFlg}
									placeholder="yyyy/mm/dd"
									dateFormat='YYYY/MM/DD'
									disabled={!openDateChkAuthFlg || formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_IMMEDIATELY}
								/>
								<TimePicker
									helperText={openTimeFormatErrFlg ? t('message.1001600') : ''}
									onChange={inputTime}
									error={openTimeFormatErrFlg}
									disabled={!openDateChkAuthFlg || formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_IMMEDIATELY}
								/>

							</div>
							{formValues.promptlyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE && (!formValues.openDate || formValues.openTime === '') && (
								<Typography className='errorMessage' variant='caption'>
									{t('message.1001400')}
								</Typography>
							)}
						</Grid>
						<Grid item md={12} className="griditem mailSendChk">
							<InputLabel required >{'8. ' + t('sendMail')}</InputLabel>
							<InputLabel className='beforeSendMailLabel'>{t('beforeSendMail')}</InputLabel>
							<Radio
								label={t('sendPublishDate')}
								checked={formValues.beforeNoSendFlg === '0'}
								disabled
							/>
							<br />
							<Radio
								label={t('noSend')}
								checked={formValues.beforeNoSendFlg === '1'}
								disabled
							/>
							<InputLabel >{t('afterSendMail')}</InputLabel>
							<Radio
								label={t('sendPublishDate')}
								checked={formValues.noSendFlg === NO_SEND_FLG.SEND}
								onChange={() => setFormValues({ ...formValues, noSendFlg: NO_SEND_FLG.SEND })}
								disabled={!mailSendChkAuthFlg || !statusFlg}
							/>
							<br />
							<Radio
								label={t('noSend')}
								checked={formValues.noSendFlg === NO_SEND_FLG.NO_SEND}
								onChange={() => setFormValues({ ...formValues, noSendFlg: NO_SEND_FLG.NO_SEND })}
								disabled={!mailSendChkAuthFlg || !statusFlg}
							/>
						</Grid>
						<Grid item md={12} className="griditem filePeriod">
							<InputLabel required style={{ marginTop: '16px' }}>{'9. ' + t('filePeriod')}</InputLabel>
							<InputLabel className='beforeFilePeriodLabel'style={{ marginTop: '16px' }}>{t('beforeFilePeriod')}</InputLabel>
							<div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '8px' }}>
								<Radio
									label="15日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.beforeFilePeriod === FILE_PERIOD.DAYS_15}
									disabled
								/>
								<Radio
									label="30日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.beforeFilePeriod === FILE_PERIOD.DAYS_30}
									disabled
								/>
								<Radio
									label="45日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.beforeFilePeriod === FILE_PERIOD.DAYS_45}
									disabled
								/>
								<Radio
									label="60日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.beforeFilePeriod === FILE_PERIOD.DAYS_60}
									disabled
								/>
								<Radio
									label="75日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.beforeFilePeriod === FILE_PERIOD.DAYS_75}
									disabled
								/>
								<Radio
									label="90日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.beforeFilePeriod === FILE_PERIOD.DAYS_90}
									disabled
								/>
							</div>
							
							<InputLabel style={{ marginTop: '16px' }}>{t('afterFilePeriod')}</InputLabel>
							<div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '8px' }}>
								<Radio
									label="15日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.filePeriod === FILE_PERIOD.DAYS_15}
									onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_15 })}
									disabled={!filePeriodAuthFlg || !statusFlg}
								/>
								<Radio
									label="30日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.filePeriod === FILE_PERIOD.DAYS_30}
									onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_30 })}
									disabled={!filePeriodAuthFlg || !statusFlg}
								/>
								<Radio
									label="45日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.filePeriod === FILE_PERIOD.DAYS_45}
									onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_45 })}
									disabled={!filePeriodAuthFlg || !statusFlg}
								/>
								<Radio
									label="60日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.filePeriod === FILE_PERIOD.DAYS_60}
									onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_60 })}
									disabled={!filePeriodAuthFlg || !statusFlg}
								/>
								<Radio
									label="75日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.filePeriod === FILE_PERIOD.DAYS_75}
									onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_75 })}
									disabled={!filePeriodAuthFlg || !statusFlg}
								/>
								<Radio
									label="90日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.filePeriod === FILE_PERIOD.DAYS_90}
									onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_90 })}
									disabled={!filePeriodAuthFlg || !statusFlg}
								/>
							</div>
						</Grid>
						<Divider className="divider" type="dark" />
						<Button
							className="uploadFileBtn"
							variant="primary"
							icon={Upload}
							disabled={showUploadProgress || errFileNameMessage.length !== 0 || blockedFileNames.length !== 0 || formValues.notices.length > 300 || formValues.information.length > 300 || openDateFormatErrFlg || openDatePastErrFlg || openTimeFormatErrFlg || (formValues.promptlyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE && (!formValues.openDate || formValues.openTime === ''))}
							onClick={handleUploadClick}
							style={{ display: uploadFileBtnAuthFlg && statusFlg ? "inline-flex" : "none" }}
						>
							{showUploadProgress ? 'ファイルアップロード中...' : t('upload')}
						</Button>
						<Button
							className="cancelBtn"
							variant="secondary"
							icon={Close}
							onClick={handleCancelClick}
						>
							{t('cancel')}
						</Button>
					</CardContent>
				</Card>
				{(dialogStatus === DIALOG_STATUS.OK_DIALOG || dialogStatus === DIALOG_STATUS.OK_DIALOG_BACK) && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onOk}
					/>
				)}
				{(dialogStatus === DIALOG_STATUS.DETAIL_DIALOG || dialogStatus === DIALOG_STATUS.DETAIL_DIALOG_BACK) && (
					<DetailDialog
						isOpen={dialogOpen}
						content={dialogContent}
						detailContent={detailContent}
						onOk={onOk}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.UPLOAD_CONFIRM_DIALOG && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={onUploadConfirmOk}
						onCancel={onCancel}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.UPLOAD_COMPLETE_DIALOG && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onCompleteOk}
					/>
				)}
			</Container>
		);
	}
}
export default UploadUpdate;
